import Role from '@/spa/role/RoleCadastro';

export default {
  path: 'role',
  name: 'role',
  component: Role,
};
